import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { MiniFacesheetContainer } from "../components/MiniFacesheet/MiniFacesheet";
import { CTA } from "@coverme/forms";
import { LoadingBar } from "../components/LoadingComponents/LoadingBar";
import { Link } from "react-router-dom";
import { Birdseed } from "@coverme/elements";
import { getPayformLink, saveTransactionDetails } from "../services/paymentCollectionService";
import { isNotNullOrWhitespace } from "../services/stringService";
import { Payform } from "../components/Paya/Payform";
import { PayaForm } from "../components/Paya/PayaForm";
import { PayaReceipt } from "../components/Paya/PayaReceipt";
import { extractCoverageCollected } from "../services/coverageService";
import { toast } from "react-toastify";

export const PaymentComponent = ({
    encounterId,
    interview,
    coverage,
    isHouseholdLoading,
    person,
    notes,
    documents,
    history,
    customer,
}) => {
    const isInterviewLoading = encounterId !== interview.encounterId;
    const hasPaymentCollected = interview.paymentDetails?.encounterId != null;
    const [payformLink, setPayformLink] = useState(null); // Needed
    const [isPaymentSucceeded, setPaymentSucceeded] = useState(false);
    const [transactionAmountBreakDown, setTransactionAmountBreakDown] = useState(null);
    const [copayLookup, setCopayLookup] = useState(null);
    const [deductibleOutOfPocket, setDeductibleOutOfPocket] = useState(null);

    function extractDeductibleAndOutOfPocket(coverage) {
        let deductibleAndOutOfPocket = {
            deductible: 0.0,
            outOfPocket: 0.0,
        };

        if (coverage === null || coverage === undefined) {
            return deductibleAndOutOfPocket;
        }

        let collectedCoverage = extractCoverageCollected(coverage);

        if (collectedCoverage === null || collectedCoverage === undefined) {
            return deductibleAndOutOfPocket;
        }

        if (
            collectedCoverage.remainingDeductible !== null &&
            collectedCoverage.remainingDeductible !== undefined &&
            collectedCoverage.remainingDeductible.inPlanNetwork !== null &&
            collectedCoverage.remainingDeductible.inPlanNetwork > 0.0
        ) {
            deductibleAndOutOfPocket.deductible = collectedCoverage.remainingDeductible.inPlanNetwork;
        }

        if (
            collectedCoverage.remainingOutOfPocket !== null &&
            collectedCoverage.remainingOutOfPocket !== undefined &&
            collectedCoverage.remainingOutOfPocket.inPlanNetwork !== null &&
            collectedCoverage.remainingOutOfPocket.inPlanNetwork > 0.0
        ) {
            deductibleAndOutOfPocket.outOfPocket = collectedCoverage.remainingOutOfPocket.inPlanNetwork;
        }

        return deductibleAndOutOfPocket;
    }

    function extractCopayLookup(coverage) {
        let collectedCoverage = extractCoverageCollected(coverage);

        let copayLookup = [];
        if (collectedCoverage?.copay != null) {
            if (collectedCoverage.copay.erInPlanNetwork > 0.0) {
                copayLookup.push("ER Copay : $" + collectedCoverage.copay.erInPlanNetwork);
            }
            if (collectedCoverage.copay.office > 0.0) {
                copayLookup.push("Office Copay : $" + collectedCoverage.copay.office);
            }
            if (collectedCoverage.copay.specialistInPlanNetwork > 0.0) {
                copayLookup.push("Specialist Copay : $" + collectedCoverage.copay.specialistInPlanNetwork);
            }
            return copayLookup;
        }
    }

    useEffect(() => {
        setCopayLookup(extractCopayLookup(coverage));
        setDeductibleOutOfPocket(extractDeductibleAndOutOfPocket(coverage));
    }, [coverage]);

    const showPaymentCollectionPage = isNotNullOrWhitespace(payformLink);

    const onSubmit = formData => {
        let responsibleParty =
            interview.entry.isResponsiblePartyDifferentFromPatient === true
                ? interview?.entry.responsibleParty
                : interview?.entry.patient;
        let data = {
            encounterId: encounterId,
            transactionId: "",
            transactionApiId: "",
            transactionAmount: formData?.transactionAmount,
            transactionAmountBreakdown: formData?.transactionBreakdown,
            accountHolderName: `${responsibleParty.firstName} ${responsibleParty.lastName}`,
            billingStreet: responsibleParty.address.line1,
            billingZipCode: responsibleParty.address.zipCode,
            stylesheetUrl: `${window.appConfiguration.identity.post_logout_redirect_uri}/payform.css`,
        };
        setTransactionAmountBreakDown(formData.transactionBreakdown);
        getPayformLink(encounterId, data).then(result => {
            setPayformLink(result);
        });
    };

    function paymentCollected() {
        setPayformLink(null);
        history.push(`/interview/${encounterId}/details/dispatch`);
    }

    if (showPaymentCollectionPage === true) {
        return (
            <div className="payformLink">
                <Payform
                    payformLink={payformLink.data}
                    transactionAmountBreakdown={transactionAmountBreakDown}
                    onSuccess={parsedData => {
                        setPaymentSucceeded(true);
                        toast.success(
                            "Payment has been successfully collected. Receipt is available on the History section of the facesheet page"
                        );
                        let payload = {
                            encounterId: encounterId,
                            transactionId: parsedData?.id,
                            transactionApiId: parsedData?.transaction_api_id,
                            transactionAmount: parsedData?.transaction_amount,
                            transactionAmountBreakdown: transactionAmountBreakDown,
                            accountHolderName: parsedData?.account_holder_name,
                            billingStreet: parsedData?.billing_street,
                            billingZipCode: parsedData?.billing_zip,
                            payformLink: payformLink.data,
                            transactionStatus: parsedData?.status_id === 101 ? "Approved" : "Unable to process",
                            orderNumber: parsedData?.order_num,
                            accountType: parsedData?.account_type,
                            reasonCode: parsedData?.reason_code_id === 1000 ? "CC - Approved" : "",
                            authCode: parsedData?.auth_code,
                            lastFour: parsedData?.last_four,
                            entryMode: parsedData?.entry_mode_id === "K" ? "Keyed" : "",
                            transactionVerbiage: parsedData?.verbiage,
                        };
                        saveTransactionDetails(encounterId, payload).then(result => {
                            console.log("Transaction Saved", result);
                        });
                    }}
                />
                <div>
                    {!isPaymentSucceeded && (
                        <>
                            <CTA
                                url="/"
                                size="large"
                                ctaType="button"
                                styleType="blue"
                                id="submit-payment"
                                click={() => {
                                    setPayformLink(null);
                                }}
                            >
                                Back
                            </CTA>
                        </>
                    )}
                    {isPaymentSucceeded && (
                        <CTA
                            url="/"
                            size="large"
                            ctaType="button"
                            styleType="blue"
                            id="submit-payment"
                            click={paymentCollected}
                        >
                            Next
                        </CTA>
                    )}
                </div>
            </div>
        );
    } else if (showPaymentCollectionPage === false) {
        return (
            <LoadingBar isLoading={isInterviewLoading || isHouseholdLoading}>
                <div>
                    <Birdseed>
                        <Link to={"/"}>Home</Link>
                        <a href="javascript:void(0)">
                            Interview / <strong>Payment</strong>{" "}
                        </a>
                    </Birdseed>
                    <div className="default-page" id="payment">
                        <MiniFacesheetContainer />
                        <div className="content">
                            {!hasPaymentCollected && (
                                <PayaForm
                                    encounterId={encounterId}
                                    onSubmit={onSubmit}
                                    coverage={coverage}
                                    customer={customer}
                                    copayLookup={copayLookup}
                                    deductibleOutOfPocket={deductibleOutOfPocket}
                                    history={history}
                                />
                            )}
                            {hasPaymentCollected && (
                                <>
                                    <PayaReceipt paymentDetails={interview.paymentDetails} />{" "}
                                    <div>
                                        <CTA
                                            url="/"
                                            size="medium"
                                            ctaType="button"
                                            styleType="blue"
                                            id="submit-payment"
                                            click={() => history.push(`/interview/${encounterId}/details/dispatch`)}
                                        >
                                            Next
                                        </CTA>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </LoadingBar>
        );
    }
};

export const PaymentContainer = connect((state, ownProps) => {
    const patientId = state.interview?.entry?.patient?.personId;
    let underlyingPerson = null;
    if (patientId) {
        underlyingPerson = state.person.data[patientId];
    }
    return {
        interview: state.interview,
        coverage: state.interview.coverage,
        encounterId: ownProps.match.params.encounterId,
        isHouseholdLoading: state.households.isInitialized === false || state.households.isLoading === true,
        person: underlyingPerson,
        notes: state.notes.data[(underlyingPerson?.globalId)],
        documents: state.documents,
        customer: state.customer,
    };
})(PaymentComponent);
